export const API_URL = 'https://api-app.mskobr.ru'
export default API_URL
